export const ALL_CONTRACT_TYPE_FORMULA_KEY = "__all__";

export const SALARY_FORMULA_GROUPS = [
  { code: "standard_work", label: "Ngày công" },
  { code: "dependent_person", label: "Số người phụ thuộc" },
  { code: "salary_level", label: "Mức lương" },
  { code: "insurance_salary", label: "Lương đóng bảo hiểm" },
  { code: "salary_income", label: "Chi tiết thu nhập" },
  { code: "taxable_income", label: "Thu nhập tính thuế TNCN" },
  { code: "insurance_total", label: "Các khoản giảm trừ" },
  { code: "total_income", label: "Tổng lương thực nhận" },
];

const SOURCE_VALUE_CODES = [
  "standard_work",
  "actual_work",
  "ot_150",
  "ot_200",
  "ot_300",
  "paid_leave",
  "unpaid_leave",
  "meal_allowance_day",
  "dependent_person",
  "salary_level",
  "insurance_salary",
  "meal_deduction",
];

const UPDATED_DEFAULT_FORMULA_CODES = [
  "salary_income",
  "ot_income",
  "meal_allowance",
  "insurance_total",
  "taxable_income",
  "tax_amount",
  "total_income",
];

const OT_INCOME_FORMULA =
  "([ot_150] * ([salary_level] / [standard_work] / 8) * 1.5) + ([ot_200] * ([salary_level] / [standard_work] / 8) * 2) + ([ot_300] * ([salary_level] / [standard_work] / 8) * 3)";

const LEGACY_FORMULA_REPLACEMENTS = {
  ot_income: {
    "[ot_income_input]": OT_INCOME_FORMULA,
  },
  meal_allowance: {
    "FLOOR([actual_work] - [paid_leave] - [unpaid_leave]) * 35000":
      "[meal_allowance_day] * 35000",
    "([actual_work] - [paid_leave] - [unpaid_leave]) * 35000":
      "[meal_allowance_day] * 35000",
  },
  taxable_income: {
    "MAX([salary_income] - [insurance_total] - 15500000 - (6200000 * [dependent_person]), 0)":
      "[salary_income] - [insurance_total] - 15500000 - 6200000 * [dependent_person]",
  },
  insurance_total: {
    "[salary_income] * 0.105": "[insurance_salary] * 0.105",
  },
  total_income: {
    "[salary_income] - [insurance_total] - [tax_amount] - [reduction_other] - [advance_amount] + [meal_allowance] + [bonus]":
      "[salary_income] - [insurance_total] - [tax_amount] - [meal_deduction] - [reduction_other] - [advance_amount] + [meal_allowance] + [bonus]",
  },
};

const DEFAULT_SALARY_FORMULA_COLUMNS = [
  {
    code: "standard_work",
    codeLabel: "ngay_cong_trong_thang",
    displayName: "Ngày công trong tháng",
    formula: "",
    description: "Lấy trực tiếp từ dữ liệu ngày công trong tháng của nhân viên.",
  },
  {
    code: "actual_work",
    codeLabel: "ngay_cong_lam_viec_thuc_te",
    displayName: "Số công làm việc thực tế",
    formula: "",
    description: "Lấy trực tiếp từ dữ liệu số công làm việc thực tế của nhân viên.",
  },
  {
    code: "ot_150",
    codeLabel: "gio_lam_them_150",
    displayName: "Số giờ làm thêm 150%",
    formula: "",
    description: "Lấy trực tiếp từ dữ liệu số giờ làm thêm 150% của nhân viên.",
  },
  {
    code: "ot_200",
    codeLabel: "gio_lam_them_200",
    displayName: "Số giờ làm thêm 200%",
    formula: "",
    description: "Lấy trực tiếp từ dữ liệu số giờ làm thêm 200% của nhân viên.",
  },
  {
    code: "ot_300",
    codeLabel: "gio_lam_them_300",
    displayName: "Số giờ làm thêm 300%",
    formula: "",
    description: "Lấy trực tiếp từ dữ liệu số giờ làm thêm 300% của nhân viên.",
  },
  {
    code: "paid_leave",
    codeLabel: "nghi_phep_co_luong",
    displayName: "Nghỉ phép có lương",
    formula: "",
    description: "Lấy trực tiếp từ dữ liệu nghỉ phép có lương của nhân viên.",
  },
  {
    code: "unpaid_leave",
    codeLabel: "nghi_khong_luong",
    displayName: "Nghỉ không lương",
    formula: "",
    description: "Lấy trực tiếp từ dữ liệu nghỉ không lương của nhân viên.",
  },
  {
    code: "meal_allowance_day",
    codeLabel: "ngay_tinh_an_trua",
    displayName: "Ngày tính ăn trưa",
    formula: "",
    description: "Số ngày có đi làm, trừ các ngày nghỉ phép hoặc không phép.",
  },
  {
    code: "dependent_person",
    codeLabel: "nguoi_phu_thuoc",
    displayName: "Số người phụ thuộc",
    formula: "",
    description: "Lấy trực tiếp từ số người phụ thuộc của nhân viên.",
  },
  {
    code: "salary_level",
    codeLabel: "muc_luong",
    displayName: "Mức lương",
    formula: "",
    description: "Lấy trực tiếp từ mức lương của nhân viên.",
  },
  {
    code: "insurance_salary",
    codeLabel: "luong_dong_bao_hiem",
    displayName: "Lương đóng bảo hiểm",
    formula: "",
    description: "Lấy trực tiếp từ lương đóng bảo hiểm trong hồ sơ nhân viên.",
  },
  {
    code: "salary_income",
    codeLabel: "luong",
    displayName: "Lương",
    formula: "([salary_level] * [actual_work]) / [standard_work]",
    description:
      "Lương được tính theo mức lương, số công làm việc thực tế và ngày công trong tháng.",
  },
  {
    code: "ot_income",
    codeLabel: "tien_ot",
    displayName: "OT",
    formula: OT_INCOME_FORMULA,
    description: "OT được tính theo số giờ làm thêm 150%, 200%, 300% và đơn giá giờ theo mức lương.",
  },
  {
    code: "meal_allowance",
    codeLabel: "an_trua",
    displayName: "Ăn trưa",
    formula: "[meal_allowance_day] * 35000",
    description: "Ăn trưa được tính theo số ngày tính ăn trưa nhân đơn giá.",
  },
  {
    code: "bonus",
    codeLabel: "thuong",
    displayName: "Thưởng",
    formula: "",
    description: "Giá trị mặc định lấy từ dữ liệu thưởng trên bảng lương.",
  },
  {
    code: "taxable_income",
    codeLabel: "thu_nhap_tinh_thue",
    displayName: "Thu nhập tính thuế TNCN",
    formula: "[salary_income] - [insurance_total] - 15500000 - 6200000 * [dependent_person]",
    description: "Thu nhập tính thuế TNCN sau khi trừ bảo hiểm và giảm trừ gia cảnh.",
  },
  {
    code: "insurance_total",
    codeLabel: "bhxh",
    displayName: "BHXH",
    formula: "[insurance_salary] * 0.105",
    description: "BHXH được tính theo lương đóng bảo hiểm và tỷ lệ bảo hiểm bắt buộc.",
  },
  {
    code: "tax_amount",
    codeLabel: "thue_tncn",
    displayName: "Thuế TNCN",
    formula: "[taxable_income] * TAXRATE([taxable_income])",
    description: "Thuế TNCN được tính theo thu nhập tính thuế và biểu thuế.",
  },
  {
    code: "meal_deduction",
    codeLabel: "khau_tru_tien_an",
    displayName: "Khấu trừ tiền ăn",
    formula: "",
    description: "Tổng tiền các suất ăn đã đăng ký và chưa hủy trong tháng lương.",
  },
  {
    code: "reduction_other",
    codeLabel: "khoan_giam_tru_khac",
    displayName: "Khoản giảm trừ khác",
    formula: "[reduction_other_input]",
    description: "Giá trị mặc định lấy từ các khoản giảm trừ khác.",
  },
  {
    code: "advance_amount",
    codeLabel: "tam_ung",
    displayName: "Tạm ứng",
    formula: "",
    description: "Giá trị mặc định lấy từ số tiền tạm ứng.",
  },
  {
    code: "total_income",
    codeLabel: "tong_luong_thuc_nhan",
    displayName: "Tổng lương thực nhận",
    formula:
      "[salary_income] - [insurance_total] - [tax_amount] - [meal_deduction] - [reduction_other] - [advance_amount] + [meal_allowance] + [bonus]",
    description: "Tổng lương thực nhận sau thu nhập, khấu trừ tiền ăn, các khoản giảm trừ, tạm ứng và phụ cấp.",
  },
];

function shouldUseSourceValueDefaults(defaultItem, savedItem) {
  return (
    SOURCE_VALUE_CODES.includes(defaultItem.code) &&
    savedItem &&
    (savedItem.formula === "" || /\[[^\]]+_input\]/.test(savedItem.formula || ""))
  );
}

function shouldMigrateFormula(defaultItem, savedItem) {
  const savedFormula = savedItem && typeof savedItem.formula === "string" ? savedItem.formula : "";
  const legacyFormulas = Object.keys(LEGACY_FORMULA_REPLACEMENTS[defaultItem.code] || {});
  return (
    UPDATED_DEFAULT_FORMULA_CODES.includes(defaultItem.code) &&
    savedItem &&
    (savedFormula === "" || /\[[^\]]+_input\]/.test(savedFormula) || legacyFormulas.includes(savedFormula))
  );
}

function normalizeFormulaByCode(code, formula, defaultValue = "") {
  const normalizedFormula = typeof formula === "string" ? formula : defaultValue;
  const replacements = LEGACY_FORMULA_REPLACEMENTS[code] || {};
  if (
    code === "insurance_total" &&
    normalizedFormula.replace(/\s+/g, "").toLowerCase() === "[salary_income]*0.105"
  ) {
    return "[insurance_salary] * 0.105";
  }
  return replacements[normalizedFormula] || normalizedFormula;
}

function normalizeContractTypeFormulas(defaultItem, savedItem) {
  const savedFormula = normalizeFormulaByCode(
    defaultItem.code,
    savedItem && typeof savedItem.formula === "string" ? savedItem.formula : "",
    ""
  );
  const savedContractTypeFormulas =
    savedItem && savedItem.contractTypeFormulas && typeof savedItem.contractTypeFormulas === "object"
      ? Object.keys(savedItem.contractTypeFormulas).reduce((result, key) => {
          result[key] = normalizeFormulaByCode(defaultItem.code, savedItem.contractTypeFormulas[key], "");
          return result;
        }, {})
      : {};

  const normalizedDefaultFormula = shouldUseSourceValueDefaults(defaultItem, savedItem)
    ? defaultItem.formula
    : shouldMigrateFormula(defaultItem, savedItem)
    ? defaultItem.formula
    : savedFormula || defaultItem.formula;

  return {
    ...savedContractTypeFormulas,
    [ALL_CONTRACT_TYPE_FORMULA_KEY]:
      savedContractTypeFormulas[ALL_CONTRACT_TYPE_FORMULA_KEY] !== undefined
        ? savedContractTypeFormulas[ALL_CONTRACT_TYPE_FORMULA_KEY]
        : normalizedDefaultFormula,
  };
}

function mapContractTypeFormulasFromApi(code, value) {
  if (Array.isArray(value)) {
    return value.reduce((result, item) => {
      const contractTypeId = `${(item && item.contract_type_id) || ""}`.trim();
      if (!contractTypeId || result[contractTypeId] !== undefined) {
        return result;
      }

      result[contractTypeId] = normalizeFormulaByCode(code, item && item.formula, "");
      return result;
    }, {});
  }

  if (value && typeof value === "object") {
    return Object.keys(value).reduce((result, key) => {
      result[key] = normalizeFormulaByCode(code, value[key], "");
      return result;
    }, {});
  }

  return undefined;
}

function mapContractTypeFormulasToApi(value) {
  if (!value || typeof value !== "object") {
    return [];
  }

  return Object.keys(value).reduce((result, contractTypeId) => {
    const normalizedContractTypeId = `${contractTypeId || ""}`.trim();
    if (!normalizedContractTypeId || normalizedContractTypeId === ALL_CONTRACT_TYPE_FORMULA_KEY) {
      return result;
    }

    result.push({
      contract_type_id: normalizedContractTypeId,
      formula: typeof value[contractTypeId] === "string" ? value[contractTypeId] : "",
    });
    return result;
  }, []);
}

function getConfigTimestamp(value) {
  if (!value) {
    return 0;
  }
  const time = new Date(value).getTime();
  return Number.isNaN(time) ? 0 : time;
}

function isNewerConfig(candidate, current) {
  if (!current) {
    return true;
  }

  const candidateUpdatedAt = getConfigTimestamp(candidate && candidate.updated_at);
  const currentUpdatedAt = getConfigTimestamp(current && current.updated_at);
  if (candidateUpdatedAt !== currentUpdatedAt) {
    return candidateUpdatedAt > currentUpdatedAt;
  }

  const candidateCreatedAt = getConfigTimestamp(candidate && candidate.created_at);
  const currentCreatedAt = getConfigTimestamp(current && current.created_at);
  return candidateCreatedAt > currentCreatedAt;
}

function getLatestConfigMapByCode(configs = []) {
  return (Array.isArray(configs) ? configs : []).reduce((result, item) => {
    if (!item || !item.code) {
      return result;
    }

    if (isNewerConfig(item, result[item.code])) {
      result[item.code] = item;
    }
    return result;
  }, {});
}

function mergeWithDefaults(configs = []) {
  const savedConfigMap = getLatestConfigMapByCode(configs);

  return DEFAULT_SALARY_FORMULA_COLUMNS.map((defaultItem) => {
    const savedItem = savedConfigMap[defaultItem.code];

    return {
      ...defaultItem,
      ...(savedItem || {}),
      contractTypeFormulas: normalizeContractTypeFormulas(defaultItem, savedItem),
      formula: shouldUseSourceValueDefaults(defaultItem, savedItem)
        ? defaultItem.formula
        : shouldMigrateFormula(defaultItem, savedItem)
        ? defaultItem.formula
        : normalizeFormulaByCode(defaultItem.code, savedItem && savedItem.formula, defaultItem.formula),
      description: shouldUseSourceValueDefaults(defaultItem, savedItem)
        ? defaultItem.description
        : (savedItem && savedItem.description) || defaultItem.description,
      code: defaultItem.code,
      codeLabel: defaultItem.codeLabel,
      displayName: defaultItem.displayName,
    };
  });
}

export function getDefaultSalaryFormulaColumns() {
  return mergeWithDefaults();
}

export function getSalaryFormulaGroupMeta(code) {
  return SALARY_FORMULA_GROUPS.find((item) => item.code === code) || null;
}

export function mapSalaryFormulaApiItemsToConfigs(apiItems = []) {
  const defaultColumns = getDefaultSalaryFormulaColumns();
  const defaultColumnMap = defaultColumns.reduce((result, item) => {
    result[item.code] = item;
    return result;
  }, {});

  const mappedItems = (Array.isArray(apiItems) ? apiItems : [])
    .map((item) => {
      const code = `${(item && item.code) || ""}`.trim();
      if (!code) {
        return null;
      }

      const defaultItem = defaultColumnMap[code] || {};
      const groupMeta = getSalaryFormulaGroupMeta(code);
      const contractTypeFormulas = mapContractTypeFormulasFromApi(
        code,
        item && item.contract_type_formulas !== undefined
          ? item.contract_type_formulas
          : item && item.contractTypeFormulas
      );

      return {
        ...defaultItem,
        id: item.id,
        company_id: item.company_id,
        created_at: item.created_at,
        updated_at: item.updated_at,
        code,
        displayName: item.name || defaultItem.displayName || "",
        formula: normalizeFormulaByCode(code, item && item.formula, defaultItem.formula || ""),
        description:
          typeof item.description === "string" ? item.description : defaultItem.description || "",
        contractTypeFormulas: contractTypeFormulas,
        sortOrder:
          item && item.sort_order !== undefined && item.sort_order !== null
            ? item.sort_order
            : undefined,
        isActive: item && item.is_active !== undefined ? item.is_active : true,
        disabled: item && item.disabled === true,
        groupKey: item.group_key || (groupMeta && groupMeta.code) || "",
        groupName: item.group_name || (groupMeta && groupMeta.label) || "",
      };
    })
    .filter(Boolean);

  return mergeWithDefaults(mappedItems).map((item, index) => ({
    ...item,
    sortOrder: item && item.sortOrder !== undefined && item.sortOrder !== null ? item.sortOrder : index,
    isActive: item && item.isActive !== false,
    disabled: item && item.disabled === true,
    groupKey: item.groupKey || (getSalaryFormulaGroupMeta(item.code) || {}).code || "",
    groupName: item.groupName || (getSalaryFormulaGroupMeta(item.code) || {}).label || "",
  }));
}

export function buildSalaryFormulaApiPayload(config, index = 0) {
  const groupMeta = getSalaryFormulaGroupMeta(config && config.code);

  return {
    ...(config && config.id ? { id: config.id } : {}),
    code: (config && config.code) || "",
    name: (config && (config.displayName || config.name)) || "",
    group_key: (config && config.groupKey) || (groupMeta && groupMeta.code) || "",
    group_name: (config && config.groupName) || (groupMeta && groupMeta.label) || "",
    formula: typeof (config && config.formula) === "string" ? config.formula : "",
    description:
      typeof (config && config.baseDescription) === "string"
        ? config.baseDescription
        : typeof (config && config.description) === "string"
        ? config.description
        : "",
    contract_type_formulas: mapContractTypeFormulasToApi(config && config.contractTypeFormulas),
    sort_order:
      config && config.sortOrder !== undefined && config.sortOrder !== null ? config.sortOrder : index,
    is_active: !(config && config.isActive === false),
    disabled: !!(config && config.disabled),
  };
}
